import {Controller} from "@hotwired/stimulus"

// Restricts time input to specific hours (5 AM to 9 PM) and quarter-hour intervals
export default class extends Controller {
  connect() {
    console.log("Connected")
    // Set min and max time values
    this.element.min = "05:00"
    this.element.max = "21:00"

    // Add event listeners
    this.element.addEventListener("input", this.restrictToQuarterHours.bind(this))
    this.element.addEventListener("change", this.restrictToQuarterHours.bind(this))

    // Apply restrictions on initial load if there's a value
    if (this.element.value) {
      this.restrictToQuarterHours()
    }
  }

  restrictToQuarterHours() {
    if (!this.element.value) return

    const timeValue = this.element.value
    const [hours, minutes] = timeValue.split(":")

    // Ensure hours are between 5 and 21 (9 PM)
    let hoursNum = parseInt(hours, 10)
    hoursNum = Math.min(Math.max(hoursNum, 5), 21)

    // Round minutes to nearest quarter hour (0, 15, 30, 45)
    let minutesNum = parseInt(minutes, 10)
    minutesNum = Math.round(minutesNum / 15) * 15
    if (minutesNum === 60) {
      minutesNum = 0
      hoursNum = hoursNum + 1

      // If rounding pushes past 9 PM, cap at 9 PM
      if (hoursNum > 21) {
        hoursNum = 21
        minutesNum = 0
      }
    }

    // Format the time values with leading zeros
    const formattedHours = String(hoursNum).padStart(2, "0")
    const formattedMinutes = String(minutesNum).padStart(2, "0")

    // Update the input value
    this.element.value = `${formattedHours}:${formattedMinutes}`
  }
}